import posthog from 'posthog-js';
import {
  apiCheckPhone,
  apiSignIn,
  apiSignUp,
  apiValidateToken,
  type AuthResponse,
  type PhoneCheckResponse,
  type ValidationResponse,
} from './auth';

export type AuthResult =
  | { success: true; name: string }
  | { success: false; error: string };

const handleLocalStorageAndAnalytics = ({
  token,
  userId,
  userName,
  phoneNumber,
}: {
  token: string;
  userId: string;
  userName: string;
  phoneNumber: string;
}): void => {
  localStorage.setItem('token', token);
  localStorage.setItem('userName', userName);

  posthog.alias(userId);
  posthog.identify(userId, {
    phone_number: phoneNumber,
    name: userName,
  });
};

export const checkPhone = async (
  phone: string
): Promise<PhoneCheckResponse> => {
  return apiCheckPhone(phone);
};

export const signIn = async (phone: string): Promise<AuthResult> => {
  try {
    const result: AuthResponse = await apiSignIn(phone);

    handleLocalStorageAndAnalytics({
      token: result.token,
      userId: result.user.id.toString(),
      userName: result.user.name,
      phoneNumber: result.user.phoneNumber,
    });

    return { success: true, name: result.user.name };
  } catch (error) {
    console.error(error);
    return { success: false, error: 'Sign in failed' };
  }
};

export const signUp = async ({
  phone,
  name,
  gender,
  instaHandle,
}: {
  phone: string;
  name: string;
  gender: string;
  instaHandle?: string;
}): Promise<AuthResult> => {
  try {
    const result: AuthResponse = await apiSignUp({
      phoneNumber: phone,
      name: name,
      gender: gender,
      instagramUsername: instaHandle,
    });

    handleLocalStorageAndAnalytics({
      token: result.token,
      userId: result.user.id.toString(),
      userName: result.user.name,
      phoneNumber: result.user.phoneNumber,
    });

    return { success: true, name: result.user.name };
  } catch (error) {
    console.error(error);
    return { success: false, error: 'Sign up failed' };
  }
};

export const validateToken = async (): Promise<AuthResult> => {
  const token = localStorage.getItem('token');
  if (!token) {
    return { success: false, error: 'No token found' };
  }

  try {
    const result: ValidationResponse = await apiValidateToken(token);

    handleLocalStorageAndAnalytics({
      token: token,
      userId: result.user.id.toString(),
      userName: result.user.name,
      phoneNumber: result.user.phoneNumber,
    });

    return { success: true, name: result.user.name };
  } catch (error) {
    console.error(error);
    localStorage.removeItem('token');
    return { success: false, error: 'Token validation failed' };
  }
};
